import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'driverName'
})
export class DriverNamePipe implements PipeTransform {

  transform(value: string[]): unknown {
    return value.toString();
  }

}
